module.exports = "/images/img_05_sp.png?a1d39b192473b506b03d1d8045eede05";